/**
 * @fileOverview This file contains the implementation of the Carousel component for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import '../../scss/Components/Inventory/_carousel.scss';
import { Box, Typography } from '@mui/material';
import Item from './Item';
//#endregion

const Carousel = ({ title, items, refreshItems }) => {
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          variant="h6"
          component="div"
          className="inventory-carousel-title"
        >
          {title}
        </Typography>
        <Box
          sx={{
            flexGrow: 1,
            borderBottom: '1px solid #000',
            ml: 2,
            opacity: '20%',
          }}
        />
      </Box>
      {items.length > 0 ? (
        <Box sx={{ overflow: 'hidden', position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              overflowX: 'scroll',
              scrollBehavior: 'smooth',
            }}
          >
            {items.map((item, index) => (
              <Item
                key={index}
                refreshItems={refreshItems}
                {...item}
              />
            ))}
          </Box>
        </Box>
      ) : (
        <Box p={2}>
          <Typography className="inventory-carousel-empty">
            No tiene productos registrados.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Carousel;
